import { Product } from 'modules/Partner/interfaces/Product';
import React from 'react';
import ImageUrl from 'shared/ImageUrl';
import {
    WrapSmallStyle,
    BorderStyle,
    ImageWrapSmall,
    ContentSmallStyle,
    PartnerWrapStyle,
    PartnerLogoStyle,
    PartnerNameStyle,
    DescStyle
} from "./style";
import Typography from "shared/Typography";
import PointPrefix from "shared/PointPrefix";
import PartnerImage from "modules/Partner/components/PartnerImage";
import {useCurrecny} from "modules/Partner/hooks/useCurrency";


type Props = {
    product: Product
    onAddCartPressed: () => void,
    onReducePressed: () => void,
    isLoading: boolean,
    width: number,
    onOpenProduct: () => void,
    quantityInCart: number,
    priceProduct: string,
    isProductForPoint: boolean
}

const ProductsItemDefaultComponent = (props: Props) => {

    const { product, onAddCartPressed, onReducePressed, isLoading, width,
        onOpenProduct, quantityInCart, priceProduct, isProductForPoint, mb,
        variant = 'primary',
        isWithoutBaseUrl,
        ...rest } = props;
    const { id, image, weight, name, description = '', price, partner, howManyTimesBought } = product;
    const { freeDeliverySum, deliveryCost  } = partner;
    const currency = useCurrecny('partner', partner);

    const deliveryText =
        freeDeliverySum > 0
            ? `Доставка бесплатно от ${freeDeliverySum} р`
            : `Доставка ${deliveryCost} р`;


    return (
        <>
            <WrapSmallStyle
                data-cy={'products-item'}
                mb={mb}
                {...rest}
                onClick={onOpenProduct}
            >
                {
                    Boolean(image) &&
                    <ImageWrapSmall>
                        <ImageUrl isWithoutBaseUrl={isWithoutBaseUrl} src={image}></ImageUrl>
                        <PartnerWrapStyle>
                            <PartnerLogoStyle>
                                <PartnerImage partner={partner}/>
                            </PartnerLogoStyle>
                            <PartnerNameStyle>
                                <Typography variant="text" color="black">
                                    {partner.name}
                                </Typography>
                            </PartnerNameStyle>
                        </PartnerWrapStyle>
                    </ImageWrapSmall>
                }

                <ContentSmallStyle>
                    <Typography variant={'h4'} component="h2" mb={0.5} maxLength={40}>{name}</Typography>
                    {
                        !!weight && (
                            <Typography variant="text" color="gray" align="center">
                                <PointPrefix prefix="г">{weight}</PointPrefix>
                            </Typography>
                        )
                    }

                    <Typography
                        mb={1}
                        variant="textBig"
                    >
                        <PointPrefix currency={currency}>{price}</PointPrefix>
                    </Typography>

                    <DescStyle>
                        <Typography
                            mb={1}
                            align={'center'}
                            variant="text"
                            color='grayMid'>{description}</Typography>
                    </DescStyle>





                    <BorderStyle/>



                    <Typography
                        isFullWidth
                        align={'center'}
                        variant="text"
                        color='grayMid'
                        mb={0.5}>
                        {deliveryText}
                    </Typography>

                    {
                        Boolean(howManyTimesBought) && (
                            <Typography
                                isFullWidth
                                mb={1}
                                align={'center'}
                                variant="text"
                                color='grayMid'>Купили {howManyTimesBought} раз</Typography>
                        )
                    }


                </ContentSmallStyle>

            </WrapSmallStyle>
        </>
    )
}

export default ProductsItemDefaultComponent
